import { createApp } from 'vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'
import { useGlobalInit } from './components/globalComposables'
// import { Platformmanager,Storemanager,Storeuser,themeQrcode} from '../public/config.js'

// ① 给 TS 声明 window.APP_CONFIG 的类型（可放这里或单独 .d.ts 文件）
declare global {
  interface Window {
    APP_CONFIG?: {
      API_BASE_URL?: string
      DEBUG_MODE?: boolean
      Platformmanager?: string[]
      Storemanager?: string[]
      Storeuser?: string[]
      themeQrcode?: string
      [k: string]: any
    }
  }
}

const app = createApp(App)

// ② 读取运行时配置（有兜底，防止 config.js 未加载时报错）
const {
  API_BASE_URL = '',
  DEBUG_MODE = false,
  Platformmanager = [],
  Storemanager = [],
  Storeuser = [],
  themeQrcode = '',
  ...rest
} = window.APP_CONFIG || {}

app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

app.config.globalProperties.$init = useGlobalInit().notify
const loadConfig = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `${import.meta.env.BASE_URL}config.js` // 加载 public/config.js
    script.onload = () => {
      resolve(window.APP_CONFIG)
    }
    script.onerror = () => {
      reject(new Error('配置文件加载失败'))
    }
    document.head.appendChild(script)
  })
}

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

loadConfig()
  .then((config) => {
    app.config.globalProperties.$Platformmanager = Platformmanager // 挂载到全局属性
    app.config.globalProperties.$Storemanager = Storemanager
    app.config.globalProperties.$Storeuser = Storeuser
    app.config.globalProperties.$themeQrcode = themeQrcode
    app.mount('#app')
  })
  .catch((error) => {
    console.error(error)
    // 处理加载配置文件失败的情况
  })
